import QuillKit from './QuillKit';
import * as Plugins from './plugins';

// Ensure InsertPlugin is always included in the bundle (prevents tree-shaking)
import InsertPlugin from './plugins/InsertPlugin';
if (typeof InsertPlugin !== 'undefined') {
  // No-op to ensure it's bundled
}

// Make QuillKit available globally
if (typeof window !== 'undefined') {
  window.QuillKit = QuillKit;

  // Also expose plugins for easy access
  window.QuillKit.Plugins = Plugins;
}

// Export plugins along with the editor
export { Plugins };
export default QuillKit;
